import { createPortal } from 'react-dom'
import { KTSVG } from '_metronic/helpers'
import { Modal } from 'react-bootstrap'
import Datetime from 'react-datetime'

import useViewModel, { Props } from './ViewModel'
import moment from 'moment'
import clsx from 'clsx'

const ProjectEventLogForm: React.FC<Props> = props => {
  const {
    isSubmitting,
    isOpen,
    formState,
    formError,
    onChangeFormState,
    onAddFileAttachment,
    onRemoveFileAttachment,
    onClose,
    onSubmit,
  } = useViewModel(props)

  return createPortal(
    <Modal
      id='kt_modal_project_add_note'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={isOpen}
      onHide={onClose}
      backdrop={isSubmitting ? 'static' : true}>
      <div className='modal-content'>
        <div className='modal-header'>
          <h2>เพิ่มบันทึกเหตุการณ์</h2>
          {/* begin::Close */}
          <div className='btn btn-sm btn-icon btn-active-light-danger' onClick={onClose}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/general/gen040.svg' />
          </div>
          {/* end::Close */}
        </div>

        <div className='modal-body py-lg-10 px-lg-10 min-h-500px'>
          <div className='mb-5'>
            <label htmlFor='type' className='form-label'>
              วันที่บันทึก <span className='required'></span>
            </label>

            <Datetime
              locale='en'
              dateFormat='DD/MM/YYYY'
              timeFormat={false}
              renderInput={props => {
                return (
                  <input
                    {...props}
                    autoComplete='off'
                    className={clsx(props.className, {
                      'is-invalid': formError.recordedAt,
                    })}
                    disabled={isSubmitting}
                  />
                )
              }}
              closeOnClickOutside
              className='filter-date-input w-100 z-4'
              value={formState.recordedAt ?? null}
              onChange={(val: any) =>
                onChangeFormState('recordedAt', moment(val).format('YYYY-MM-DD'))
              }
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='note' className='form-label'>
              ข้อความบันทึก <span className='required' />
            </label>
            <textarea
              name='note'
              rows={5}
              className={clsx('form-control form-control-sm', {
                'is-invalid': formError.note,
              })}
              value={formState.note}
              onChange={(e: any) => onChangeFormState('note', e.target.value)}
              disabled={isSubmitting}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='noteBy' className='form-label'>
              บันทึกโดย
            </label>
            <input
              name='noteBy'
              type='text'
              className={clsx('form-control form-control-sm', {
                'is-invalid': formError.noteBy,
              })}
              value={formState.noteBy}
              onChange={(e: any) => onChangeFormState('noteBy', e.target.value)}
              disabled={isSubmitting}
            />
          </div>

          <div className='mb-5'>
            <label htmlFor='attachments' className='form-label'>
              ไฟล์แนบ
            </label>
            <div>
              <div
                className={clsx('border-dashed w-100 h-150px bg-hover-light transition-500', {
                  'opacity-50': isSubmitting,
                })}
                style={{
                  pointerEvents: isSubmitting ? 'none' : 'auto',
                }}
                onClick={() => {
                  if (!isSubmitting) {
                    document.getElementById('attach-file-input')?.click()
                  }
                }}>
                <div className='d-flex flex-column align-items-center justify-content-center h-100 cursor-pointer'>
                  {isSubmitting ? (
                    <div className='d-flex flex-column align-items-center'>
                      <div className='spinner-border text-primary' role='status'>
                        <span className='visually-hidden'>Loading...</span>
                      </div>
                      <p className='text-gray-500 fw-bold fs-3 mb-5 mt-5'>Uploading...</p>
                    </div>
                  ) : (
                    <>
                      <KTSVG
                        className='svg-icon-5x svg-icon-primary'
                        path='/media/icons/duotune/general/gen006.svg'
                      />
                      <p className='text-gray-500 fw-bold fs-3 mb-5 mt-5'>Browse Files</p>
                      <p className='text-gray-400'>Supports: PDF, DOC, DOCX, PNG, JPG, JPEG</p>
                    </>
                  )}

                  <input
                    id='attach-file-input'
                    type='file'
                    className='d-none'
                    accept='.pdf,.doc,.docx,.png,.jpg,.jpeg'
                    multiple
                    disabled={isSubmitting}
                    onChange={(e: any) => {
                      onAddFileAttachment(e.target.files as FileList)
                      // @ts-ignore
                      e.target.value = ''
                    }}
                  />
                </div>
              </div>

              <div className='mt-5'>
                {formState.attachments.map((file: any, index: number) => (
                  <div key={index} className='d-flex align-items-center mb-2'>
                    <KTSVG
                      path='/media/icons/duotune/files/fil005.svg'
                      svgClassName='svg-icon-2x svg-icon-primary me-3'
                    />
                    <span className='me-3'>{file.name}</span>
                    <button
                      type='button'
                      className={clsx('btn btn-sm btn-light btn-active-light-danger', {
                        'opacity-50': isSubmitting,
                      })}
                      onClick={() => onRemoveFileAttachment(index)}
                      disabled={isSubmitting}>
                      ลบ
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='modal-footer'>
          <button
            className={clsx('btn btn-light fw-bold', {
              'opacity-50': isSubmitting,
            })}
            onClick={onClose}
            disabled={isSubmitting}>
            ยกเลิก
          </button>
          <button
            className={clsx('btn btn-primary fw-bold', {
              'indicator indicator-progress opacity-50': isSubmitting,
            })}
            onClick={onSubmit}
            disabled={isSubmitting}>
            บันทึก
          </button>
        </div>
      </div>
    </Modal>,
    document.body
  )
}

export default ProjectEventLogForm
